import { ModalBody, ModalTitle } from '@strava/ui/Modal';
import React, { useEffect, useRef } from 'react';
import StravaAlert from 'components/StravaAlert';
import clsx from '@strava/ui/clsx';
import { t } from '../../../../shared/onboarding-utils';
import { useOnboardingContext } from '../../../../state/OnboardingContext';
import styles from './CreateProfile.scss';
import {
  CLEAR_ALERT,
  UPDATE_CURRENT_ATHLETE
} from '../../../../state/Onboarding.actions';
import { INPUT_IDS } from '../../../../shared/onboarding-constants';

const PREFIX = 'create_your_profile';

const CreateProfile = () => {
  const firstNameInputRef = useRef(null);
  const lastNameInputRef = useRef(null);

  const { state, dispatch } = useOnboardingContext();
  const { currentAthlete, alert } = state;
  const { firstName, lastName } = currentAthlete;

  useEffect(() => {
    if (alert?.target === INPUT_IDS.firstName) {
      firstNameInputRef.current.focus();
    }
    if (alert?.target === INPUT_IDS.lastName) {
      lastNameInputRef.current.focus();
    }
  }, [alert]);

  const handleNameChange = (event) => {
    dispatch({ type: CLEAR_ALERT });
    const { target } = event;
    const { name } = target;

    dispatch({
      type: UPDATE_CURRENT_ATHLETE,
      payload: { [name]: target.value }
    });

    const nameChangeEvent = new CustomEvent('OnBoardingNameChange', {
      bubbles: true
    });
    target.dispatchEvent(nameChangeEvent);
  };

  return (
    <>
      <ModalTitle id="onboarding-step-title">{t(`${PREFIX}.title`)}</ModalTitle>
      <ModalBody>
        {alert && (
          <StravaAlert severity={alert.severity}>{alert.message}</StravaAlert>
        )}
        <p className={styles.subtitle}>{t(`${PREFIX}.subtitle`)}</p>

        <div className={styles.row}>
          <div className={styles.formGroup}>
            <label
              htmlFor={INPUT_IDS.firstName}
              className={clsx(
                alert?.target === INPUT_IDS.firstName && styles.error
              )}
            >
              {t(`${PREFIX}.profile_details.first_name`)}
            </label>
            <input
              id={INPUT_IDS.firstName}
              name={INPUT_IDS.firstName}
              type="text"
              className={clsx(
                styles.formControl,
                alert?.target === INPUT_IDS.firstName && styles.error
              )}
              value={firstName}
              onChange={handleNameChange}
              autoComplete="off"
              ref={firstNameInputRef}
            />
          </div>

          <div className={styles.formGroup}>
            <label
              htmlFor={INPUT_IDS.lastName}
              className={clsx(
                alert?.target === INPUT_IDS.lastName && styles.error
              )}
            >
              {t(`${PREFIX}.profile_details.last_name`)}
            </label>
            <input
              id={INPUT_IDS.lastName}
              name={INPUT_IDS.lastName}
              type="text"
              className={clsx(
                styles.formControl,
                alert?.target === INPUT_IDS.lastName && styles.error
              )}
              onChange={handleNameChange}
              value={lastName}
              autoComplete="off"
              ref={lastNameInputRef}
            />
          </div>
        </div>
      </ModalBody>
    </>
  );
};

export default CreateProfile;
